export default number => {
    const decimals = number - Math.floor(number)

    if(decimals < 0.5) {
        return [Math.floor(number), - decimals]
    } else {
        return [Math.ceil(number), 1 - decimals]
    }
}